module.exports = __webpack_public_path__ + "static/media/ipoc.6c8d69b7.png";